export const NavbarLinks = [
    {
      title: "About us",
      path: "#about"
    },
    {
      title: "Contact us",
      path: "#contact",
    },
    {
      title: "Features",
      path: "#feature",
    },
  ];
   
  